<template>
  <v-card :elevation="0" class="sc-record-card mx-auto">
    <v-list-item three-line data-track="contact.picker.select" @click="clickHandler">
      <div class="sc-record-avatar mr-3">
        <v-avatar
          size="60"
          rounded="lg"
        >
          <img :src="item.img || contactPlaceholder" alt="">
        </v-avatar>
      </div>
      <v-list-item-content>
        <div class="headline mb-1">
          {{ item.first_name }} <strong>{{ item.last_name }}</strong>
        </div>
        <div>
          Title:
          <span>
            {{ item.title || '-' }}
          </span>
        </div>
        <div>
          Email:
          <a v-if="item.email" :href="`mailto:${item.email}`">
            <span>{{ item.email }}</span>
          </a>
          <span v-else>-</span>
        </div>
        <div>
          Direct Phone:
          <a v-if="item.phone.direct" :href="`tel:${item.phone.direct}`">
            <span>{{ item.phone.direct | formatPhone }}</span>
          </a>
          <span v-else>-</span>
        </div>
        <div>
          Company:
          <span class="contact-company">{{ item.company ? item.company.name : '-' }}</span>
        </div>
      </v-list-item-content>
      <v-list-item-action class="mr-3">
        <v-checkbox
          :value="selected"
          :disabled="disabled"
        />
      </v-list-item-action>
    </v-list-item>
  </v-card>
</template>

<script lang="ts">
import Vue, { PropType } from 'vue';

export default Vue.extend({
  name: 'ContactSelectItem',

  props: {
    item: {
      type: Object as PropType<any>, // TODO: add proper type when model created
      required: true
    },
    disabled: Boolean,
    selected: Boolean
  },

  methods: {
    clickHandler () {
      if (!this.disabled) {
        this.$emit('toggleSelect', this.item._id);
      }
    }
  }
});
</script>

<style lang="scss" scoped>
  .sc-record-card {
    cursor: pointer;
  }

  .title {
    white-space: nowrap;
    font-weight: normal;
  }
</style>
